import { useCallback, useEffect, useState } from 'react';
import { fetchJson, type OrgSummary, type ActiveOrg } from '@/lib/api';

export function useActiveOrg() {
  const [orgs, setOrgs] = useState<OrgSummary[]>([]);
  const [active, setActive] = useState<ActiveOrg | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const [orgList, activeOrg] = await Promise.all([
        fetchJson<OrgSummary[]>('/api/me/orgs'),
        fetchJson<ActiveOrg>('/api/me/active-org').catch(() => null)
      ]);
      setOrgs(orgList);
      setActive(activeOrg);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const switchOrg = useCallback(
    async (orgId: string) => {
      await fetchJson('/api/active-org', {
        method: 'POST',
        body: JSON.stringify({ orgId })
      });
      window.location.reload();
    },
    []
  );

  return { orgs, active, loading, refresh, switchOrg };
}
